import { Form, FormProps } from "antd";
import { FC } from "react";

interface IVuiFormLayout extends FormProps {}

const VuiFormLayout: FC<IVuiFormLayout> = (props) => {
  const {
    children,
    requiredMark = true,
    layout = "vertical",
    ...other
  } = props;

  return (
    <Form requiredMark={requiredMark} layout={layout} {...other}>
      {children}
    </Form>
  );
};

export default VuiFormLayout;
